import React from 'react';
import Widget from 'components/Widget/Widget';
import PropTypes from 'prop-types';
import { Skeleton } from 'antd';
import Icon from '@mdi/react';
import { mdiFinance } from '@mdi/js';
import NetworkWidget from 'components/widgets/components/NetworkWidget';
import { useDashboardTotalsQuery } from 'store/redux/apis/dashboard.api';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';

const defaultData = {
  gross_income: 0,
  gross_profit: 0,
  net_profit: 0,
  ad_spent: 0,
};

const TotalProfitsAndLosses = ({ movingButton, height, data, index, configuration }) => {
  const { date_from, date_to, date_range_key } = useWidgetDate('totalPnL_widget' + index);

  const filters = {
    date_from,
    date_to,
    date_range_key,
    ...data.defaultFilter,
  };

  const { data: response, isLoading } = useDashboardTotalsQuery(filters);
  const dataList = response?.data || defaultData;

  return (
    <Widget
      title={data.title}
      icon={<Icon path={mdiFinance} className='text-orange' />}
      movingButton={movingButton}
      widget_key={'totalPnL_widget' + index}
      configuration={configuration}
      disableLimit
      disableStatusFilter
      disableLevelFilter
      bodyStyle={{
        height: height - 60,
      }}
      networkSwitch={false}
      default_filter={data?.defaultFilter}
      index={index}
      adsFilter
      adsetFilter
      campaignFilter
      disableDateFilter
      showDatePicker
    >
      <Skeleton loading={isLoading} active={true}>
        <NetworkWidget data={dataList} />
      </Skeleton>
    </Widget>
  );
};

export default TotalProfitsAndLosses;

TotalProfitsAndLosses.propTypes = {
  movingButton: PropTypes.element.isRequired,
  height: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
